<!--
 * @Author: zdx 3539255028@qq.com
 * @Date: 2022-06-16 16:29:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-22 14:19:05
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\modules\dataBoard\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="data-board">
    <div class="head">
      <h2>Dashboard</h2>
      <div class="right">
        <a-select
          allowClear
          :style="{ width: '254px' }"
          v-model="curGroupId"
          @change="_getUserByRolTenantId()"
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          placeholder="请选择企业/组织"
        >
          <a-select-option v-for="item in tenants" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
        <a-switch v-model="isAutoLoadding" @change="changeHandle" :style="{ margin: '-3px 8px 0 16px' }"></a-switch>
        <span>自动刷新</span>
        <a-tooltip title="全屏" class="tip">
          <img @click="requestFullScreen" src="@/assets/workbench/fullScreen.png" alt="" />
        </a-tooltip>
        <a-tooltip title="刷新" class="tip">
          <img @click="refresh" src="@/assets/workbench/refresh.png" alt="" />
        </a-tooltip>
        <a-tooltip title="导出" class="tip">
          <img @click="isExport = true" src="@/assets/workbench/export.png" alt="" />
        </a-tooltip>
      </div>
    </div>
    <div class="content">
      <ul class="echarts">
        <li class="echarts-item">
          <Chart
            :title="'用户数据'"
            :range="userRange"
            :select="userDateSelect"
            :option="userChartOption"
            :hideDays="true"
            @changeDate="refreshUserChart"
            @showDetail="showUserDetail"
          ></Chart>
        </li>
        <li class="echarts-item">
          <Chart
            :title="'用户活跃度'"
            :range="userActiveRange"
            :select="userActiveDateSelect"
            :option="userActiveChartOption"
            @changeDate="refreshUserActiveChart"
            @showDetail="showUserActiveDetail"
          ></Chart>
        </li>
        <li class="echarts-item echarts-item-wide">
          <TabChart
            :options="tabChartOptions"
            :range="tabChartRange"
            :select="tabChartDateSelect"
            :allUsers="users"
            :selectedUsers="selectedUsers"
            @changeData="refreshTabChart"
            @changeTab="changeTab"
          ></TabChart>
        </li>
      </ul>
      <div class="download">
        <div class="title">
          <h3>方案下载动态</h3>
        </div>
        <ul v-if="downDetails.length > 0">
          <li class="li" v-for="item in downDetails" :key="item.id">
            <div class="avatar">
              <img :src="item.avatar" alt="" />
            </div>
            <div class="record-item">
              <p>
                <span>{{ item.realName }}</span
                >下载方案<span>{{ item.solutionName }}</span
                >单元数量：<span>{{ item.rpsNumber }}</span
                >个
              </p>
              <span class="time">{{ item.date }}</span>
            </div>
          </li>
        </ul>
        <div class="empty" v-else>
          <a-empty></a-empty>
        </div>
        <a-pagination
          @change="_getHisRpsDownload"
          v-model="pageNumber"
          :pageSize="pageSize"
          :total="total"
          size="small"
        ></a-pagination>
      </div>
    </div>
    <Export
      v-if="isExport"
      :relTenantId="curGroupId"
      :user="{
        userStartTime: userRange[0],
        userEndTime: userRange[1]
      }"
      :userLogin="{
        userLoginStartTime: userActiveRange[0],
        userLoginEndTime: userActiveRange[1]
      }"
      :solution="{
        solutionStartTime: tabChartRange[0],
        solutionEndTime: tabChartRange[1],
        solutionCreateBy: selectedUsers
      }"
      :rpsDownload="{
        rpsDownloadStartTime: tabChartRange[0],
        rpsDownloadEndTime: tabChartRange[1],
        rpsCreateBy: selectedUsers
      }"
      :rpsTimeType="tabChartDateSelect === 1 ? 'day' : 'month'"
      :userLoginTimeType="userActiveDateSelect === 1 ? 'day' : 'month'"
      :userTimeType="userDateSelect === 1 ? 'day' : 'month'"
      :rpsOrSolution="rpsOrSolution"
      :visible="isExport"
      @close="isExport = false"
    />
    <DetailModal
      :title="modalTitle"
      :visible="isDetailModalActive"
      @close="isDetailModalActive = false"
      :columns="detailModalColumns"
      :data="detailModalData"
    ></DetailModal>
    <!-- <Active :visible="isActive" @close="isActive = false" /> -->
  </div>
</template>
<script>
import Export from './export.vue'
import Active from './active.vue'
import Chart from './chart/chart.vue'
import TabChart from './chart/tabChart.vue'
import DetailModal from './detailModal/detailModal.vue'
import * as echarts from 'echarts/core'
import { LineChart, BarChart, ScatterChart, HeatmapChart } from 'echarts/charts'
import {
  TitleComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  CalendarComponent,
  VisualMapComponent
} from 'echarts/components'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import { mapState } from 'vuex'
import {
  getUserByRolTenantId,
  getUserStatistics,
  getUserStatisticsDetail,
  getSolutionDownloadNumber,
  getRpsDownloadNumber,
  getHisRpsDownload,
  getUserLoginStatistics,
  getTenantList,
  getUserLoginStatisticsDetail
} from '@/api/api'
import moment from 'moment'
import { uuid } from './uuid'

export const EN_DATE_SELECT = {
  DAY: 1,
  MONTH: 2
}

echarts.use([
  LineChart,
  BarChart,
  ScatterChart,
  HeatmapChart,
  CanvasRenderer,
  LabelLayout,
  TitleComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  CalendarComponent,
  VisualMapComponent
])

export default {
  components: {
    Export,
    Active,
    Chart,
    TabChart,
    DetailModal
  },
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      tenants: [],
      curMonth: moment(),
      userRange: [],
      userDateSelect: EN_DATE_SELECT.MONTH,
      userChartOption: {},
      userActiveRange: [],
      userActiveDateSelect: EN_DATE_SELECT.MONTH,
      userActiveChartOption: {},
      tabChartRange: [],
      tabChartDateSelect: EN_DATE_SELECT.MONTH,
      tabChartOptions: [{ title: '' }, { title: '' }],
      users: [],
      selectedUsers: [],

      isExport: false,
      isActive: false,
      isUnitDown: false,
      curGroupId: undefined,
      isAutoLoadding: null,
      downDetails: [],
      pageNumber: 1,
      pageSize: 10,
      total: 28,
      dateList: [],
      lunarData: [],
      heatmapData: [],
      timeId: '',

      isDetailModalActive: false,
      modalTitle: '',
      detailModalColumns: [],
      detailModalData: [],
      rpsOrSolution: 'solution'
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        clearInterval(this.timeId)
      },
      // 深度观察监听
      deep: true
    }
  },
  async mounted() {
    this.getTenantList()
    this.isAutoLoadding = false
    this.curMonth = moment().add(-1, 'months')
    const start = moment().add(-12, 'months')
    this.userRange = [start, this.curMonth]
    this.userActiveRange = [start, this.curMonth]
    this.tabChartRange = [start, this.curMonth]
    this._getUserByRolTenantId()
  },
  methods: {
    changeHandle() {
      if (this.isAutoLoadding) {
        this.timeId = setInterval(() => {
          this.refresh()
        }, 30000)
      } else {
        clearInterval(this.timeId)
      }
    },
    async refreshUserChart(params) {
      this.userDateSelect = params.select
      this.userRange = params.range
      this.userChartOption = await this.getUserChartOption()
    },

    async getUserChartOption() {
      const { result } = await getUserStatistics({
        relTenantId: this.curGroupId,
        startTime: moment(this.userRange[0]).format('yyy/MM/DD'),
        endTime: moment(this.userRange[1]).format('yyy/MM/DD'),
        timeType: this.userDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })
      console.log(result)
      return {
        legend: [
          {
            data: ['用户累计数量', '用户活跃数'],
            orient: 'horizontal',
            bottom: '20px',
            left: '60px',
            textStyle: {
              color: '#666'
            }
          }
        ],
        grid: {
          left: '60px',
          right: '60px'
        },
        xAxis: [
          {
            type: 'category',
            data: result.map(r => r.date.replaceAll('-', '/')),
            axisLine: {
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          },
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999',
                width: 1
              }
            },
            max: Math.round(1.6 * Math.max(...result.map(item => item.number)))
          }
        ],
        tooltip: [
          {
            trigger: 'axis',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            shadowColor: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
            textStyle: {
              color: '#fff'
            },
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#CCCCCC'
              }
            }
          }
        ],
        series: [
          {
            name: '用户累计数量',
            data: result.map(item => item.totalNumber),
            type: 'bar',
            barMaxWidth: 14,
            itemStyle: {
              color: '#64ACFF'
            }
          },
          {
            name: '用户活跃数',
            data: result.map(item => item.number),
            yAxisIndex: 1,
            type: 'line',
            itemStyle: {
              color: '#FF9F00'
            },
            symbol: 'circle',
            symbolSize: 5
          }
        ]
      }
    },
    async refreshUserActiveChart(params) {
      this.userActiveDateSelect = params.select
      this.userActiveRange = params.range
      this.userActiveChartOption = await this.getUserActiveChartOption()
    },
    async getUserActiveChartOption() {
      const { result } = await getUserLoginStatistics({
        relTenantId: this.curGroupId,
        startTime: moment(this.userActiveRange[0]).format('yyy/MM/DD'),
        endTime: moment(this.userActiveRange[1]).format('yyy/MM/DD'),
        timeType: this.userActiveDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })
      return {
        legend: [
          {
            data: ['用户月累计时长(h)', '平均停留时长(h)'],
            orient: 'horizontal',
            bottom: '20px',
            left: '60px',
            textStyle: {
              color: '#666'
            }
          }
        ],
        grid: {
          left: '60px',
          right: '60px'
        },
        xAxis: [
          {
            type: 'category',
            data: result.map(r => r.date.replaceAll('-', '/')),
            axisLine: {
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999',
                width: 1
              }
            }
          },
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999',
                width: 1
              }
            },
            max: Math.round(1.6 * Math.max(...result.map(item => item.activeTime / 60)))
          }
        ],
        tooltip: [
          {
            trigger: 'axis',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            shadowColor: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
            textStyle: {
              color: '#fff'
            },
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#CCCCCC'
              }
            }
          }
        ],
        series: [
          {
            name: '用户月累计时长(h)',
            data: result.map(item => item.userNumber),
            type: 'bar',
            barMaxWidth: 14,
            itemStyle: {
              color: '#64ACFF'
            }
          },
          {
            name: '平均停留时长(h)',
            yAxisIndex: 1,
            data: result.map(item => Math.round(item.activeTime / 0.6) / 100),
            type: 'line',
            itemStyle: {
              color: '#FF9F00'
            },
            symbol: 'circle',
            symbolSize: 5
          }
        ]
      }
    },
    async refreshTabChart(params) {
      this.tabChartDateSelect = params.select === undefined ? EN_DATE_SELECT.DAY : params.select
      this.tabChartRange = params.range === undefined ? [] : params.range
      this.selectedUsers = params.users === undefined ? [] : params.users
      this.tabChartOptions = await this.getTabChartOptions()
    },
    async getTabChartOptions() {
      const solutionDownloadOption = await this._getSolutionDownloadOption()
      const unitDownChartOption = await this._getUnitDownChartOption()
      return [
        {
          title: '单元下载数量',
          option: unitDownChartOption
        },
        {
          title: '方案下载数量',
          option: solutionDownloadOption
        }
      ]
    },
    async _getSolutionDownloadOption() {
      const { result } = await getSolutionDownloadNumber({
        relTenantId: this.curGroupId,
        startTime: moment(this.tabChartRange[0]).format('yyy/MM/DD'),
        endTime: moment(this.tabChartRange[1]).format('yyy/MM/DD'),
        createBy: this.selectedUsers.join(',') || null,
        timeType: this.tabChartDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })
      return {
        legend: {
          orient: 'horizontal',
          bottom: '20px',
          left: '60px',
          textStyle: {
            color: '#666'
          }
        },
        grid: {
          left: '60px',
          right: '60px'
        },
        label: {
          show: true,
          position: 'top'
        },
        xAxis: {
          type: 'category',
          data: result.map(r => r.date.replaceAll('-', '/')),
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999',
              width: 1
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          shadowColor: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
          textStyle: {
            color: '#fff'
          },
          formatter: function(params) {
            const item = params[0]
            const a = result.find(res => res.date.replaceAll('-', '/') === item.axisValue)
            return `${
              item.axisValue
            }<br/><span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:${
              item.color
            }"></span>用户方案下载量：${item.data}<br/><span style="margin-left: 15px">累计下载总量：</span>${
              a ? a.totalRpsNumber : 0
            }`
          }
        },
        series: [
          {
            name: '用户方案下载量',
            data: result.map(item => item.rpsNumber),
            type: 'line',
            itemStyle: {
              color: '#64ACFF'
            },
            symbol: 'circle',
            symbolSize: 5,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#83BCFF'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            }
          }
        ]
      }
    },
    async _getUnitDownChartOption() {
      const { result } = await getRpsDownloadNumber({
        relTenantId: this.curGroupId,
        startTime: moment(this.tabChartRange[0]).format('yyy/MM/DD'),
        endTime: moment(this.tabChartRange[1]).format('yyy/MM/DD'),
        createBy: this.selectedUsers.join(',') || null,
        timeType: this.tabChartDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })
      this.unitDownArr = result
      return {
        legend: {
          orient: 'horizontal',
          bottom: '20px',
          left: '30px',
          textStyle: {
            color: '#666'
          }
        },
        label: {
          show: true,
          position: 'top'
        },
        grid: {
          left: '60px',
          right: '60px'
        },
        xAxis: {
          data: result.map(r => r.date.replaceAll('-', '/')),
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999',
              width: 1
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          shadowColor: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
          textStyle: {
            color: '#fff'
          },
          formatter: function(params) {
            const item = params[0]
            const a = result.find(res => res.date.replaceAll('-', '/') === item.axisValue)
            return `${
              item.axisValue
            }<br/><span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:${
              item.color
            }"></span>用户单元下载量：${item.data}<br/><span style="margin-left: 15px">累计下载总量：</span>${
              a ? a.totalRpsNumber : 0
            }`
          }
        },
        series: [
          {
            name: '用户单元下载量',
            data: result.map(item => item.rpsNumber),
            type: 'line',
            itemStyle: {
              color: '#64ACFF'
            },
            symbol: 'circle',
            symbolSize: 5,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#83BCFF'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            }
          }
        ]
      }
    },
    async getTenantList() {
      const { result } = await getTenantList({
        pageNo: 1,
        pageSize: 999,
        pageNumber: 1,
        order: 'desc'
      })
      this.tenants = result.records
    },
    async refresh() {
      this.userChartOption = await this.getUserChartOption()
      this.userActiveChartOption = await this.getUserActiveChartOption()
      this.tabChartOptions = await this.getTabChartOptions()
      this._getHisRpsDownload()
    },
    async _getHisRpsDownload() {
      const { total, result } = await getHisRpsDownload({
        relTenantId: this.curGroupId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      })
      this.total = total
      this.downDetails = result.map(item => ({
        ...item,
        avatar: item.avatar
          ? item.avatar.startsWith('http')
            ? item.avatar
            : `${window._CONFIG['ossPathUrl']}${item.avatar}`
          : require('@/assets/workbench/user-img.png'),
        id: uuid()
      }))
    },
    async _getUserByRolTenantId() {
      if (this.timeId) {
        clearInterval(this.timeId)
      }
      this.pageNumber = 1
      const { result } = await getUserByRolTenantId({
        relTenantId: this.curGroupId
      })
      this.users = result.map(({ id, realname, phone, avatar, relTenantIds }) => ({
        id,
        realname,
        avatar,
        phone,
        relTenantIds
      }))
      this.refresh()
      this.timeId = setInterval(() => {
        this.refresh()
      }, 30000)
    },

    async showUserDetail(date) {
      this.detailModalColumns = [
        { title: '组织', dataIndex: 'relTenantName', width: '40%' },
        { title: '累计用户数', dataIndex: 'totalNumber', width: '20%' },
        { title: '新增用户数', dataIndex: 'number', width: '20%' }
      ]
      const { result } = await getUserStatisticsDetail({
        startTime: date,
        timeType: this.userDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })

      this.detailModalData = result.map(data => {
        return { ...data, key: data.relTenantId }
      })
      this.modalTitle = '用户数据详情'
      this.isDetailModalActive = true
    },
    async showUserActiveDetail(date) {
      this.detailModalColumns = [
        { title: '组织', dataIndex: 'relTenantName', width: '40%' },
        { title: '活跃用户数', dataIndex: 'userNumber', width: '20%' },
        { title: '活跃总时长(h)', dataIndex: 'activeTime', width: '20%' }
      ]

      const { result } = await getUserLoginStatisticsDetail({
        date,
        timeType: this.userActiveDateSelect === EN_DATE_SELECT.DAY ? 'day' : 'month'
      })
      this.detailModalData = result.map(data => {
        return { ...data, key: data.relTenantId, activeTime: Math.round(data.activeTime / 0.6) / 100 }
      })
      this.modalTitle = '用户活跃度详情'
      this.isDetailModalActive = true
    },
    changeTab(index) {
      this.rpsOrSolution = index === 0 ? 'solution' : 'rps'
    },
    requestFullScreen() {
      document.body.requestFullscreen()
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
